import { render, staticRenderFns } from "./PopUps.vue?vue&type=template&id=149b2af6&scoped=true"
import script from "./PopUps.vue?vue&type=script&lang=js"
export * from "./PopUps.vue?vue&type=script&lang=js"
import style0 from "./PopUps.vue?vue&type=style&index=0&id=149b2af6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b2af6",
  null
  
)

export default component.exports